import React from 'react'
import { Form, Button, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap'
import './styles.scss'
import { FaImage, FaLink, FaEraser } from 'react-icons/fa'

function TextEditor(props) {
    const [Text, setText] = React.useState('');
    const [Imgshow, setImgShow] = React.useState(false);
    const [Linkshow, setLinkShow] = React.useState(false);

    // add image
    const addImage = () => {
        var ImageUrl = document.getElementById("ImageUrl").value;
        document.getElementById("displayarea").innerHTML +=
            `<img src="${ImageUrl}" alt=""/><br/>`;
        setImgShow(false);
        props.callFunction(document.getElementById("displayarea").innerHTML);
    }

    // add Url
    const addUrl = () => {
        var Url = document.getElementById("Url").value;
        var Title = document.getElementById("TitleUrl").value
        document.getElementById("displayarea").innerHTML +=
            `<a href="${Url}" target="_blank rel="noreferrer">${Title}</a>`;
        setLinkShow(false);
        props.callFunction(document.getElementById("displayarea").innerHTML);
    }

    // add text 
    const handleChange = () => {
        document.getElementById("displayarea").innerHTML +=
            `<p>${Text}</p>`;
        setText('');
        props.callFunction(document.getElementById("displayarea").innerHTML);
    }

    const BoldText = () => {
        document.getElementById("displayarea").innerHTML +=
            `<p class="heading">${Text}</p>`;
        setText('');
        props.callFunction(document.getElementById("displayarea").innerHTML);
    }

    // clear preview function
    const clearPreview = () => {
        document.getElementById("displayarea").innerHTML = "";
        setText('');
    }

    return (
        <div className="TextEditor">

            {/* Image Modal  */}
            <Modal show={Imgshow} onHide={() => setImgShow(false)}>
                <Modal.Body>
                    <Form.Control
                        placeholder="Enter the image url..."
                        aria-label="Enter the image url..."
                        aria-describedby="basic-addon1"
                        id="ImageUrl"
                    />
                    <Form.Text muted>
                        Note: To get the image URL 'right click' on the image and select "copy image link" (or) "copy image address"
                    </Form.Text>
                    <br />
                    <Button onClick={addImage}>upload</Button>
                </Modal.Body>
            </Modal>

            {/* Link Modal  */}
            <Modal show={Linkshow} onHide={() => setLinkShow(false)}>
                <Modal.Body>
                    <Form.Control
                        placeholder="Enter title of url..."
                        aria-label="Enter title of url..."
                        aria-describedby="basic-addon1"
                        id="TitleUrl"
                    />
                    <br />
                    <Form.Control
                        placeholder="Enter the url"
                        aria-label="Enter the url"
                        aria-describedby="basic-addon1"
                        id="Url"
                    />
                    <br />
                    <Button onClick={addUrl}>Add URL</Button>
                </Modal.Body>
            </Modal>

            preview:
            <div id="displayarea" className="displayarea">
                {/* appending dynamically */}
            </div>
            <br />
            <Form.Group required>
                <Form.Label>Your message</Form.Label>
                {/* text area  */}
                <Form.Control as="textarea" placeholder="Text in this area is temporary. Use below buttons to add to preview.." onChange={(e) => setText(e.target.value)} value={Text} />
                <div style={{ float: 'right', display: 'flex', margin: '10px 0' }}>

                    {/* Handle button */}
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                add above text to preview
                            </Tooltip>
                        }
                    >
                        <Button className="editBtn" onClick={handleChange}>A</Button>
                    </OverlayTrigger>

                    {/* Heading text  */}
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                add above text as heading
                            </Tooltip>
                        }
                    >

                        <Button style={{ fontFamily: 'Poppins' }} className="editBtn" onClick={BoldText}>H</Button>
                    </OverlayTrigger>

                    {/* add image to preview */}
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                add Image
                            </Tooltip>
                        }
                    >
                        <Button className="editBtn" onClick={() => setImgShow(true)}><FaImage /></Button>
                    </OverlayTrigger>


                    {/* Add link to preview */}
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                add link (or) URL
                            </Tooltip>
                        }
                    >
                        <Button className="editBtn" onClick={() => setLinkShow(true)}><FaLink /></Button>
                    </OverlayTrigger>

                    {/* clear preview */}
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                erase all changes
                            </Tooltip>
                        }
                    >
                        <Button className="editBtn" onClick={clearPreview}><FaEraser /></Button>
                    </OverlayTrigger>
                </div>
            </Form.Group>
            <br />
        </div>
    )
}
export default TextEditor
